/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as CtraderCallbackRouteImport } from './routes/ctrader-callback'
import { Route as AboutRouteImport } from './routes/about'
import { Route as DashboardRouteImport } from './routes/_dashboard'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthIndexRouteImport } from './routes/auth/index'
import { Route as VerifySlugRouteImport } from './routes/verify/$slug'
import { Route as UnsubscribeTokenRouteImport } from './routes/unsubscribe/$token'
import { Route as AuthCodeRouteImport } from './routes/auth/code'
import { Route as AuthSignUpIndexRouteImport } from './routes/auth/sign-up/index'
import { Route as AuthResetPasswordIndexRouteImport } from './routes/auth/reset-password/index'
import { Route as AuthForgotPasswordIndexRouteImport } from './routes/auth/forgot-password/index'
import { Route as DashboardDashboardIndexRouteImport } from './routes/_dashboard/dashboard/index'
import { Route as DashboardDashboardPropfirmsRouteRouteImport } from './routes/_dashboard/dashboard/propfirms/route'
import { Route as DashboardDashboardCommunitiesRouteRouteImport } from './routes/_dashboard/dashboard/communities/route'
import { Route as DashboardDashboardTradingViewIndexRouteImport } from './routes/_dashboard/dashboard/trading-view/index'
import { Route as DashboardDashboardTradingTerminalIndexRouteImport } from './routes/_dashboard/dashboard/trading-terminal/index'
import { Route as DashboardDashboardSettingsIndexRouteImport } from './routes/_dashboard/dashboard/settings/index'
import { Route as DashboardDashboardRiskIndexRouteImport } from './routes/_dashboard/dashboard/risk/index'
import { Route as DashboardDashboardReportBugIndexRouteImport } from './routes/_dashboard/dashboard/report-bug/index'
import { Route as DashboardDashboardRanksIndexRouteImport } from './routes/_dashboard/dashboard/ranks/index'
import { Route as DashboardDashboardRankingIndexRouteImport } from './routes/_dashboard/dashboard/ranking/index'
import { Route as DashboardDashboardPropfirmsIndexRouteImport } from './routes/_dashboard/dashboard/propfirms/index'
import { Route as DashboardDashboardOptionsFlowIndexRouteImport } from './routes/_dashboard/dashboard/options-flow/index'
import { Route as DashboardDashboardMetrixIndexRouteImport } from './routes/_dashboard/dashboard/metrix/index'
import { Route as DashboardDashboardEconomicTerminalIndexRouteImport } from './routes/_dashboard/dashboard/economic-terminal/index'
import { Route as DashboardDashboardEconomicCalendarIndexRouteImport } from './routes/_dashboard/dashboard/economic-calendar/index'
import { Route as DashboardDashboardDiscordIndexRouteImport } from './routes/_dashboard/dashboard/discord/index'
import { Route as DashboardDashboardCtraderIndexRouteImport } from './routes/_dashboard/dashboard/ctrader/index'
import { Route as DashboardDashboardCopyPositionsIndexRouteImport } from './routes/_dashboard/dashboard/copy-positions/index'
import { Route as DashboardDashboardContactUsIndexRouteImport } from './routes/_dashboard/dashboard/contact-us/index'
import { Route as DashboardDashboardCommunitiesIndexRouteImport } from './routes/_dashboard/dashboard/communities/index'
import { Route as DashboardDashboardChartIndexRouteImport } from './routes/_dashboard/dashboard/chart/index'
import { Route as DashboardDashboardAffiliationIndexRouteImport } from './routes/_dashboard/dashboard/affiliation/index'
import { Route as DashboardDashboardAdminIndexRouteImport } from './routes/_dashboard/dashboard/admin/index'
import { Route as DashboardDashboardAccountsIndexRouteImport } from './routes/_dashboard/dashboard/accounts/index'
import { Route as DashboardDashboardPropfirmsSlugRouteImport } from './routes/_dashboard/dashboard/propfirms/$slug'
import { Route as DashboardDashboardCommunitiesSlugRouteImport } from './routes/_dashboard/dashboard/communities/$slug'
import { Route as DashboardDashboardAdminUsersRouteImport } from './routes/_dashboard/dashboard/admin/users'
import { Route as DashboardDashboardAdminServersRouteImport } from './routes/_dashboard/dashboard/admin/servers'
import { Route as DashboardDashboardAdminPartnersRouteImport } from './routes/_dashboard/dashboard/admin/partners'
import { Route as DashboardDashboardAdminCommunitiesRouteImport } from './routes/_dashboard/dashboard/admin/communities'
import { Route as DashboardDashboardAdminAnnouncementsRouteImport } from './routes/_dashboard/dashboard/admin/announcements'
import { Route as DashboardDashboardSettingsSubscriptionIndexRouteImport } from './routes/_dashboard/dashboard/settings/subscription/index'
import { Route as DashboardDashboardSettingsInvoicesIndexRouteImport } from './routes/_dashboard/dashboard/settings/invoices/index'
import { Route as DashboardDashboardQuantSimulationIndexRouteImport } from './routes/_dashboard/dashboard/quant/simulation/index'
import { Route as DashboardDashboardQuantOptimizationIndexRouteImport } from './routes/_dashboard/dashboard/quant/optimization/index'
import { Route as DashboardDashboardQuantExecutionIndexRouteImport } from './routes/_dashboard/dashboard/quant/execution/index'
import { Route as DashboardDashboardQuantDocumentationIndexRouteImport } from './routes/_dashboard/dashboard/quant/documentation/index'
import { Route as DashboardDashboardQuantAlgorithmsIndexRouteImport } from './routes/_dashboard/dashboard/quant/algorithms/index'
import { Route as DashboardDashboardMetrixUserIdIndexRouteImport } from './routes/_dashboard/dashboard/metrix/$userId/index'
import { Route as DashboardDashboardQuantExecutionDeploymentIdRouteImport } from './routes/_dashboard/dashboard/quant/execution/$deploymentId'
import { Route as DashboardDashboardQuantAlgorithmsAlgorithmIdRouteImport } from './routes/_dashboard/dashboard/quant/algorithms/$algorithmId'

const CtraderCallbackRoute = CtraderCallbackRouteImport.update({
  id: '/ctrader-callback',
  path: '/ctrader-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/auth/',
  path: '/auth/',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifySlugRoute = VerifySlugRouteImport.update({
  id: '/verify/$slug',
  path: '/verify/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const UnsubscribeTokenRoute = UnsubscribeTokenRouteImport.update({
  id: '/unsubscribe/$token',
  path: '/unsubscribe/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCodeRoute = AuthCodeRouteImport.update({
  id: '/auth/code',
  path: '/auth/code',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignUpIndexRoute = AuthSignUpIndexRouteImport.update({
  id: '/auth/sign-up/',
  path: '/auth/sign-up/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthResetPasswordIndexRoute = AuthResetPasswordIndexRouteImport.update({
  id: '/auth/reset-password/',
  path: '/auth/reset-password/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthForgotPasswordIndexRoute = AuthForgotPasswordIndexRouteImport.update({
  id: '/auth/forgot-password/',
  path: '/auth/forgot-password/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardDashboardIndexRoute = DashboardDashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardDashboardPropfirmsRouteRoute =
  DashboardDashboardPropfirmsRouteRouteImport.update({
    id: '/dashboard/propfirms',
    path: '/dashboard/propfirms',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDashboardCommunitiesRouteRoute =
  DashboardDashboardCommunitiesRouteRouteImport.update({
    id: '/dashboard/communities',
    path: '/dashboard/communities',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDashboardTradingViewIndexRoute =
  DashboardDashboardTradingViewIndexRouteImport.update({
    id: '/dashboard/trading-view/',
    path: '/dashboard/trading-view/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDashboardTradingTerminalIndexRoute =
  DashboardDashboardTradingTerminalIndexRouteImport.update({
    id: '/dashboard/trading-terminal/',
    path: '/dashboard/trading-terminal/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDashboardSettingsIndexRoute =
  DashboardDashboardSettingsIndexRouteImport.update({
    id: '/dashboard/settings/',
    path: '/dashboard/settings/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDashboardRiskIndexRoute =
  DashboardDashboardRiskIndexRouteImport.update({
    id: '/dashboard/risk/',
    path: '/dashboard/risk/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDashboardReportBugIndexRoute =
  DashboardDashboardReportBugIndexRouteImport.update({
    id: '/dashboard/report-bug/',
    path: '/dashboard/report-bug/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDashboardRanksIndexRoute =
  DashboardDashboardRanksIndexRouteImport.update({
    id: '/dashboard/ranks/',
    path: '/dashboard/ranks/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDashboardRankingIndexRoute =
  DashboardDashboardRankingIndexRouteImport.update({
    id: '/dashboard/ranking/',
    path: '/dashboard/ranking/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDashboardPropfirmsIndexRoute =
  DashboardDashboardPropfirmsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardDashboardPropfirmsRouteRoute,
  } as any)
const DashboardDashboardOptionsFlowIndexRoute =
  DashboardDashboardOptionsFlowIndexRouteImport.update({
    id: '/dashboard/options-flow/',
    path: '/dashboard/options-flow/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDashboardMetrixIndexRoute =
  DashboardDashboardMetrixIndexRouteImport.update({
    id: '/dashboard/metrix/',
    path: '/dashboard/metrix/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDashboardEconomicTerminalIndexRoute =
  DashboardDashboardEconomicTerminalIndexRouteImport.update({
    id: '/dashboard/economic-terminal/',
    path: '/dashboard/economic-terminal/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDashboardEconomicCalendarIndexRoute =
  DashboardDashboardEconomicCalendarIndexRouteImport.update({
    id: '/dashboard/economic-calendar/',
    path: '/dashboard/economic-calendar/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDashboardDiscordIndexRoute =
  DashboardDashboardDiscordIndexRouteImport.update({
    id: '/dashboard/discord/',
    path: '/dashboard/discord/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDashboardCtraderIndexRoute =
  DashboardDashboardCtraderIndexRouteImport.update({
    id: '/dashboard/ctrader/',
    path: '/dashboard/ctrader/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDashboardCopyPositionsIndexRoute =
  DashboardDashboardCopyPositionsIndexRouteImport.update({
    id: '/dashboard/copy-positions/',
    path: '/dashboard/copy-positions/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDashboardContactUsIndexRoute =
  DashboardDashboardContactUsIndexRouteImport.update({
    id: '/dashboard/contact-us/',
    path: '/dashboard/contact-us/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDashboardCommunitiesIndexRoute =
  DashboardDashboardCommunitiesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardDashboardCommunitiesRouteRoute,
  } as any)
const DashboardDashboardChartIndexRoute =
  DashboardDashboardChartIndexRouteImport.update({
    id: '/dashboard/chart/',
    path: '/dashboard/chart/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDashboardAffiliationIndexRoute =
  DashboardDashboardAffiliationIndexRouteImport.update({
    id: '/dashboard/affiliation/',
    path: '/dashboard/affiliation/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDashboardAdminIndexRoute =
  DashboardDashboardAdminIndexRouteImport.update({
    id: '/dashboard/admin/',
    path: '/dashboard/admin/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDashboardAccountsIndexRoute =
  DashboardDashboardAccountsIndexRouteImport.update({
    id: '/dashboard/accounts/',
    path: '/dashboard/accounts/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDashboardPropfirmsSlugRoute =
  DashboardDashboardPropfirmsSlugRouteImport.update({
    id: '/$slug',
    path: '/$slug',
    getParentRoute: () => DashboardDashboardPropfirmsRouteRoute,
  } as any)
const DashboardDashboardCommunitiesSlugRoute =
  DashboardDashboardCommunitiesSlugRouteImport.update({
    id: '/$slug',
    path: '/$slug',
    getParentRoute: () => DashboardDashboardCommunitiesRouteRoute,
  } as any)
const DashboardDashboardAdminUsersRoute =
  DashboardDashboardAdminUsersRouteImport.update({
    id: '/dashboard/admin/users',
    path: '/dashboard/admin/users',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDashboardAdminServersRoute =
  DashboardDashboardAdminServersRouteImport.update({
    id: '/dashboard/admin/servers',
    path: '/dashboard/admin/servers',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDashboardAdminPartnersRoute =
  DashboardDashboardAdminPartnersRouteImport.update({
    id: '/dashboard/admin/partners',
    path: '/dashboard/admin/partners',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDashboardAdminCommunitiesRoute =
  DashboardDashboardAdminCommunitiesRouteImport.update({
    id: '/dashboard/admin/communities',
    path: '/dashboard/admin/communities',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDashboardAdminAnnouncementsRoute =
  DashboardDashboardAdminAnnouncementsRouteImport.update({
    id: '/dashboard/admin/announcements',
    path: '/dashboard/admin/announcements',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDashboardSettingsSubscriptionIndexRoute =
  DashboardDashboardSettingsSubscriptionIndexRouteImport.update({
    id: '/dashboard/settings/subscription/',
    path: '/dashboard/settings/subscription/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDashboardSettingsInvoicesIndexRoute =
  DashboardDashboardSettingsInvoicesIndexRouteImport.update({
    id: '/dashboard/settings/invoices/',
    path: '/dashboard/settings/invoices/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDashboardQuantSimulationIndexRoute =
  DashboardDashboardQuantSimulationIndexRouteImport.update({
    id: '/dashboard/quant/simulation/',
    path: '/dashboard/quant/simulation/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDashboardQuantOptimizationIndexRoute =
  DashboardDashboardQuantOptimizationIndexRouteImport.update({
    id: '/dashboard/quant/optimization/',
    path: '/dashboard/quant/optimization/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDashboardQuantExecutionIndexRoute =
  DashboardDashboardQuantExecutionIndexRouteImport.update({
    id: '/dashboard/quant/execution/',
    path: '/dashboard/quant/execution/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDashboardQuantDocumentationIndexRoute =
  DashboardDashboardQuantDocumentationIndexRouteImport.update({
    id: '/dashboard/quant/documentation/',
    path: '/dashboard/quant/documentation/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDashboardQuantAlgorithmsIndexRoute =
  DashboardDashboardQuantAlgorithmsIndexRouteImport.update({
    id: '/dashboard/quant/algorithms/',
    path: '/dashboard/quant/algorithms/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDashboardMetrixUserIdIndexRoute =
  DashboardDashboardMetrixUserIdIndexRouteImport.update({
    id: '/dashboard/metrix/$userId/',
    path: '/dashboard/metrix/$userId/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDashboardQuantExecutionDeploymentIdRoute =
  DashboardDashboardQuantExecutionDeploymentIdRouteImport.update({
    id: '/dashboard/quant/execution/$deploymentId',
    path: '/dashboard/quant/execution/$deploymentId',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDashboardQuantAlgorithmsAlgorithmIdRoute =
  DashboardDashboardQuantAlgorithmsAlgorithmIdRouteImport.update({
    id: '/dashboard/quant/algorithms/$algorithmId',
    path: '/dashboard/quant/algorithms/$algorithmId',
    getParentRoute: () => DashboardRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/ctrader-callback': typeof CtraderCallbackRoute
  '/auth/code': typeof AuthCodeRoute
  '/unsubscribe/$token': typeof UnsubscribeTokenRoute
  '/verify/$slug': typeof VerifySlugRoute
  '/auth': typeof AuthIndexRoute
  '/dashboard/communities': typeof DashboardDashboardCommunitiesRouteRouteWithChildren
  '/dashboard/propfirms': typeof DashboardDashboardPropfirmsRouteRouteWithChildren
  '/dashboard': typeof DashboardDashboardIndexRoute
  '/auth/forgot-password': typeof AuthForgotPasswordIndexRoute
  '/auth/reset-password': typeof AuthResetPasswordIndexRoute
  '/auth/sign-up': typeof AuthSignUpIndexRoute
  '/dashboard/admin/announcements': typeof DashboardDashboardAdminAnnouncementsRoute
  '/dashboard/admin/communities': typeof DashboardDashboardAdminCommunitiesRoute
  '/dashboard/admin/partners': typeof DashboardDashboardAdminPartnersRoute
  '/dashboard/admin/servers': typeof DashboardDashboardAdminServersRoute
  '/dashboard/admin/users': typeof DashboardDashboardAdminUsersRoute
  '/dashboard/communities/$slug': typeof DashboardDashboardCommunitiesSlugRoute
  '/dashboard/propfirms/$slug': typeof DashboardDashboardPropfirmsSlugRoute
  '/dashboard/accounts': typeof DashboardDashboardAccountsIndexRoute
  '/dashboard/admin': typeof DashboardDashboardAdminIndexRoute
  '/dashboard/affiliation': typeof DashboardDashboardAffiliationIndexRoute
  '/dashboard/chart': typeof DashboardDashboardChartIndexRoute
  '/dashboard/communities/': typeof DashboardDashboardCommunitiesIndexRoute
  '/dashboard/contact-us': typeof DashboardDashboardContactUsIndexRoute
  '/dashboard/copy-positions': typeof DashboardDashboardCopyPositionsIndexRoute
  '/dashboard/ctrader': typeof DashboardDashboardCtraderIndexRoute
  '/dashboard/discord': typeof DashboardDashboardDiscordIndexRoute
  '/dashboard/economic-calendar': typeof DashboardDashboardEconomicCalendarIndexRoute
  '/dashboard/economic-terminal': typeof DashboardDashboardEconomicTerminalIndexRoute
  '/dashboard/metrix': typeof DashboardDashboardMetrixIndexRoute
  '/dashboard/options-flow': typeof DashboardDashboardOptionsFlowIndexRoute
  '/dashboard/propfirms/': typeof DashboardDashboardPropfirmsIndexRoute
  '/dashboard/ranking': typeof DashboardDashboardRankingIndexRoute
  '/dashboard/ranks': typeof DashboardDashboardRanksIndexRoute
  '/dashboard/report-bug': typeof DashboardDashboardReportBugIndexRoute
  '/dashboard/risk': typeof DashboardDashboardRiskIndexRoute
  '/dashboard/settings': typeof DashboardDashboardSettingsIndexRoute
  '/dashboard/trading-terminal': typeof DashboardDashboardTradingTerminalIndexRoute
  '/dashboard/trading-view': typeof DashboardDashboardTradingViewIndexRoute
  '/dashboard/quant/algorithms/$algorithmId': typeof DashboardDashboardQuantAlgorithmsAlgorithmIdRoute
  '/dashboard/quant/execution/$deploymentId': typeof DashboardDashboardQuantExecutionDeploymentIdRoute
  '/dashboard/metrix/$userId': typeof DashboardDashboardMetrixUserIdIndexRoute
  '/dashboard/quant/algorithms': typeof DashboardDashboardQuantAlgorithmsIndexRoute
  '/dashboard/quant/documentation': typeof DashboardDashboardQuantDocumentationIndexRoute
  '/dashboard/quant/execution': typeof DashboardDashboardQuantExecutionIndexRoute
  '/dashboard/quant/optimization': typeof DashboardDashboardQuantOptimizationIndexRoute
  '/dashboard/quant/simulation': typeof DashboardDashboardQuantSimulationIndexRoute
  '/dashboard/settings/invoices': typeof DashboardDashboardSettingsInvoicesIndexRoute
  '/dashboard/settings/subscription': typeof DashboardDashboardSettingsSubscriptionIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/ctrader-callback': typeof CtraderCallbackRoute
  '/auth/code': typeof AuthCodeRoute
  '/unsubscribe/$token': typeof UnsubscribeTokenRoute
  '/verify/$slug': typeof VerifySlugRoute
  '/auth': typeof AuthIndexRoute
  '/dashboard': typeof DashboardDashboardIndexRoute
  '/auth/forgot-password': typeof AuthForgotPasswordIndexRoute
  '/auth/reset-password': typeof AuthResetPasswordIndexRoute
  '/auth/sign-up': typeof AuthSignUpIndexRoute
  '/dashboard/admin/announcements': typeof DashboardDashboardAdminAnnouncementsRoute
  '/dashboard/admin/communities': typeof DashboardDashboardAdminCommunitiesRoute
  '/dashboard/admin/partners': typeof DashboardDashboardAdminPartnersRoute
  '/dashboard/admin/servers': typeof DashboardDashboardAdminServersRoute
  '/dashboard/admin/users': typeof DashboardDashboardAdminUsersRoute
  '/dashboard/communities/$slug': typeof DashboardDashboardCommunitiesSlugRoute
  '/dashboard/propfirms/$slug': typeof DashboardDashboardPropfirmsSlugRoute
  '/dashboard/accounts': typeof DashboardDashboardAccountsIndexRoute
  '/dashboard/admin': typeof DashboardDashboardAdminIndexRoute
  '/dashboard/affiliation': typeof DashboardDashboardAffiliationIndexRoute
  '/dashboard/chart': typeof DashboardDashboardChartIndexRoute
  '/dashboard/communities': typeof DashboardDashboardCommunitiesIndexRoute
  '/dashboard/contact-us': typeof DashboardDashboardContactUsIndexRoute
  '/dashboard/copy-positions': typeof DashboardDashboardCopyPositionsIndexRoute
  '/dashboard/ctrader': typeof DashboardDashboardCtraderIndexRoute
  '/dashboard/discord': typeof DashboardDashboardDiscordIndexRoute
  '/dashboard/economic-calendar': typeof DashboardDashboardEconomicCalendarIndexRoute
  '/dashboard/economic-terminal': typeof DashboardDashboardEconomicTerminalIndexRoute
  '/dashboard/metrix': typeof DashboardDashboardMetrixIndexRoute
  '/dashboard/options-flow': typeof DashboardDashboardOptionsFlowIndexRoute
  '/dashboard/propfirms': typeof DashboardDashboardPropfirmsIndexRoute
  '/dashboard/ranking': typeof DashboardDashboardRankingIndexRoute
  '/dashboard/ranks': typeof DashboardDashboardRanksIndexRoute
  '/dashboard/report-bug': typeof DashboardDashboardReportBugIndexRoute
  '/dashboard/risk': typeof DashboardDashboardRiskIndexRoute
  '/dashboard/settings': typeof DashboardDashboardSettingsIndexRoute
  '/dashboard/trading-terminal': typeof DashboardDashboardTradingTerminalIndexRoute
  '/dashboard/trading-view': typeof DashboardDashboardTradingViewIndexRoute
  '/dashboard/quant/algorithms/$algorithmId': typeof DashboardDashboardQuantAlgorithmsAlgorithmIdRoute
  '/dashboard/quant/execution/$deploymentId': typeof DashboardDashboardQuantExecutionDeploymentIdRoute
  '/dashboard/metrix/$userId': typeof DashboardDashboardMetrixUserIdIndexRoute
  '/dashboard/quant/algorithms': typeof DashboardDashboardQuantAlgorithmsIndexRoute
  '/dashboard/quant/documentation': typeof DashboardDashboardQuantDocumentationIndexRoute
  '/dashboard/quant/execution': typeof DashboardDashboardQuantExecutionIndexRoute
  '/dashboard/quant/optimization': typeof DashboardDashboardQuantOptimizationIndexRoute
  '/dashboard/quant/simulation': typeof DashboardDashboardQuantSimulationIndexRoute
  '/dashboard/settings/invoices': typeof DashboardDashboardSettingsInvoicesIndexRoute
  '/dashboard/settings/subscription': typeof DashboardDashboardSettingsSubscriptionIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_dashboard': typeof DashboardRouteWithChildren
  '/about': typeof AboutRoute
  '/ctrader-callback': typeof CtraderCallbackRoute
  '/auth/code': typeof AuthCodeRoute
  '/unsubscribe/$token': typeof UnsubscribeTokenRoute
  '/verify/$slug': typeof VerifySlugRoute
  '/auth/': typeof AuthIndexRoute
  '/_dashboard/dashboard/communities': typeof DashboardDashboardCommunitiesRouteRouteWithChildren
  '/_dashboard/dashboard/propfirms': typeof DashboardDashboardPropfirmsRouteRouteWithChildren
  '/_dashboard/dashboard/': typeof DashboardDashboardIndexRoute
  '/auth/forgot-password/': typeof AuthForgotPasswordIndexRoute
  '/auth/reset-password/': typeof AuthResetPasswordIndexRoute
  '/auth/sign-up/': typeof AuthSignUpIndexRoute
  '/_dashboard/dashboard/admin/announcements': typeof DashboardDashboardAdminAnnouncementsRoute
  '/_dashboard/dashboard/admin/communities': typeof DashboardDashboardAdminCommunitiesRoute
  '/_dashboard/dashboard/admin/partners': typeof DashboardDashboardAdminPartnersRoute
  '/_dashboard/dashboard/admin/servers': typeof DashboardDashboardAdminServersRoute
  '/_dashboard/dashboard/admin/users': typeof DashboardDashboardAdminUsersRoute
  '/_dashboard/dashboard/communities/$slug': typeof DashboardDashboardCommunitiesSlugRoute
  '/_dashboard/dashboard/propfirms/$slug': typeof DashboardDashboardPropfirmsSlugRoute
  '/_dashboard/dashboard/accounts/': typeof DashboardDashboardAccountsIndexRoute
  '/_dashboard/dashboard/admin/': typeof DashboardDashboardAdminIndexRoute
  '/_dashboard/dashboard/affiliation/': typeof DashboardDashboardAffiliationIndexRoute
  '/_dashboard/dashboard/chart/': typeof DashboardDashboardChartIndexRoute
  '/_dashboard/dashboard/communities/': typeof DashboardDashboardCommunitiesIndexRoute
  '/_dashboard/dashboard/contact-us/': typeof DashboardDashboardContactUsIndexRoute
  '/_dashboard/dashboard/copy-positions/': typeof DashboardDashboardCopyPositionsIndexRoute
  '/_dashboard/dashboard/ctrader/': typeof DashboardDashboardCtraderIndexRoute
  '/_dashboard/dashboard/discord/': typeof DashboardDashboardDiscordIndexRoute
  '/_dashboard/dashboard/economic-calendar/': typeof DashboardDashboardEconomicCalendarIndexRoute
  '/_dashboard/dashboard/economic-terminal/': typeof DashboardDashboardEconomicTerminalIndexRoute
  '/_dashboard/dashboard/metrix/': typeof DashboardDashboardMetrixIndexRoute
  '/_dashboard/dashboard/options-flow/': typeof DashboardDashboardOptionsFlowIndexRoute
  '/_dashboard/dashboard/propfirms/': typeof DashboardDashboardPropfirmsIndexRoute
  '/_dashboard/dashboard/ranking/': typeof DashboardDashboardRankingIndexRoute
  '/_dashboard/dashboard/ranks/': typeof DashboardDashboardRanksIndexRoute
  '/_dashboard/dashboard/report-bug/': typeof DashboardDashboardReportBugIndexRoute
  '/_dashboard/dashboard/risk/': typeof DashboardDashboardRiskIndexRoute
  '/_dashboard/dashboard/settings/': typeof DashboardDashboardSettingsIndexRoute
  '/_dashboard/dashboard/trading-terminal/': typeof DashboardDashboardTradingTerminalIndexRoute
  '/_dashboard/dashboard/trading-view/': typeof DashboardDashboardTradingViewIndexRoute
  '/_dashboard/dashboard/quant/algorithms/$algorithmId': typeof DashboardDashboardQuantAlgorithmsAlgorithmIdRoute
  '/_dashboard/dashboard/quant/execution/$deploymentId': typeof DashboardDashboardQuantExecutionDeploymentIdRoute
  '/_dashboard/dashboard/metrix/$userId/': typeof DashboardDashboardMetrixUserIdIndexRoute
  '/_dashboard/dashboard/quant/algorithms/': typeof DashboardDashboardQuantAlgorithmsIndexRoute
  '/_dashboard/dashboard/quant/documentation/': typeof DashboardDashboardQuantDocumentationIndexRoute
  '/_dashboard/dashboard/quant/execution/': typeof DashboardDashboardQuantExecutionIndexRoute
  '/_dashboard/dashboard/quant/optimization/': typeof DashboardDashboardQuantOptimizationIndexRoute
  '/_dashboard/dashboard/quant/simulation/': typeof DashboardDashboardQuantSimulationIndexRoute
  '/_dashboard/dashboard/settings/invoices/': typeof DashboardDashboardSettingsInvoicesIndexRoute
  '/_dashboard/dashboard/settings/subscription/': typeof DashboardDashboardSettingsSubscriptionIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/ctrader-callback'
    | '/auth/code'
    | '/unsubscribe/$token'
    | '/verify/$slug'
    | '/auth'
    | '/dashboard/communities'
    | '/dashboard/propfirms'
    | '/dashboard'
    | '/auth/forgot-password'
    | '/auth/reset-password'
    | '/auth/sign-up'
    | '/dashboard/admin/announcements'
    | '/dashboard/admin/communities'
    | '/dashboard/admin/partners'
    | '/dashboard/admin/servers'
    | '/dashboard/admin/users'
    | '/dashboard/communities/$slug'
    | '/dashboard/propfirms/$slug'
    | '/dashboard/accounts'
    | '/dashboard/admin'
    | '/dashboard/affiliation'
    | '/dashboard/chart'
    | '/dashboard/communities/'
    | '/dashboard/contact-us'
    | '/dashboard/copy-positions'
    | '/dashboard/ctrader'
    | '/dashboard/discord'
    | '/dashboard/economic-calendar'
    | '/dashboard/economic-terminal'
    | '/dashboard/metrix'
    | '/dashboard/options-flow'
    | '/dashboard/propfirms/'
    | '/dashboard/ranking'
    | '/dashboard/ranks'
    | '/dashboard/report-bug'
    | '/dashboard/risk'
    | '/dashboard/settings'
    | '/dashboard/trading-terminal'
    | '/dashboard/trading-view'
    | '/dashboard/quant/algorithms/$algorithmId'
    | '/dashboard/quant/execution/$deploymentId'
    | '/dashboard/metrix/$userId'
    | '/dashboard/quant/algorithms'
    | '/dashboard/quant/documentation'
    | '/dashboard/quant/execution'
    | '/dashboard/quant/optimization'
    | '/dashboard/quant/simulation'
    | '/dashboard/settings/invoices'
    | '/dashboard/settings/subscription'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/ctrader-callback'
    | '/auth/code'
    | '/unsubscribe/$token'
    | '/verify/$slug'
    | '/auth'
    | '/dashboard'
    | '/auth/forgot-password'
    | '/auth/reset-password'
    | '/auth/sign-up'
    | '/dashboard/admin/announcements'
    | '/dashboard/admin/communities'
    | '/dashboard/admin/partners'
    | '/dashboard/admin/servers'
    | '/dashboard/admin/users'
    | '/dashboard/communities/$slug'
    | '/dashboard/propfirms/$slug'
    | '/dashboard/accounts'
    | '/dashboard/admin'
    | '/dashboard/affiliation'
    | '/dashboard/chart'
    | '/dashboard/communities'
    | '/dashboard/contact-us'
    | '/dashboard/copy-positions'
    | '/dashboard/ctrader'
    | '/dashboard/discord'
    | '/dashboard/economic-calendar'
    | '/dashboard/economic-terminal'
    | '/dashboard/metrix'
    | '/dashboard/options-flow'
    | '/dashboard/propfirms'
    | '/dashboard/ranking'
    | '/dashboard/ranks'
    | '/dashboard/report-bug'
    | '/dashboard/risk'
    | '/dashboard/settings'
    | '/dashboard/trading-terminal'
    | '/dashboard/trading-view'
    | '/dashboard/quant/algorithms/$algorithmId'
    | '/dashboard/quant/execution/$deploymentId'
    | '/dashboard/metrix/$userId'
    | '/dashboard/quant/algorithms'
    | '/dashboard/quant/documentation'
    | '/dashboard/quant/execution'
    | '/dashboard/quant/optimization'
    | '/dashboard/quant/simulation'
    | '/dashboard/settings/invoices'
    | '/dashboard/settings/subscription'
  id:
    | '__root__'
    | '/'
    | '/_dashboard'
    | '/about'
    | '/ctrader-callback'
    | '/auth/code'
    | '/unsubscribe/$token'
    | '/verify/$slug'
    | '/auth/'
    | '/_dashboard/dashboard/communities'
    | '/_dashboard/dashboard/propfirms'
    | '/_dashboard/dashboard/'
    | '/auth/forgot-password/'
    | '/auth/reset-password/'
    | '/auth/sign-up/'
    | '/_dashboard/dashboard/admin/announcements'
    | '/_dashboard/dashboard/admin/communities'
    | '/_dashboard/dashboard/admin/partners'
    | '/_dashboard/dashboard/admin/servers'
    | '/_dashboard/dashboard/admin/users'
    | '/_dashboard/dashboard/communities/$slug'
    | '/_dashboard/dashboard/propfirms/$slug'
    | '/_dashboard/dashboard/accounts/'
    | '/_dashboard/dashboard/admin/'
    | '/_dashboard/dashboard/affiliation/'
    | '/_dashboard/dashboard/chart/'
    | '/_dashboard/dashboard/communities/'
    | '/_dashboard/dashboard/contact-us/'
    | '/_dashboard/dashboard/copy-positions/'
    | '/_dashboard/dashboard/ctrader/'
    | '/_dashboard/dashboard/discord/'
    | '/_dashboard/dashboard/economic-calendar/'
    | '/_dashboard/dashboard/economic-terminal/'
    | '/_dashboard/dashboard/metrix/'
    | '/_dashboard/dashboard/options-flow/'
    | '/_dashboard/dashboard/propfirms/'
    | '/_dashboard/dashboard/ranking/'
    | '/_dashboard/dashboard/ranks/'
    | '/_dashboard/dashboard/report-bug/'
    | '/_dashboard/dashboard/risk/'
    | '/_dashboard/dashboard/settings/'
    | '/_dashboard/dashboard/trading-terminal/'
    | '/_dashboard/dashboard/trading-view/'
    | '/_dashboard/dashboard/quant/algorithms/$algorithmId'
    | '/_dashboard/dashboard/quant/execution/$deploymentId'
    | '/_dashboard/dashboard/metrix/$userId/'
    | '/_dashboard/dashboard/quant/algorithms/'
    | '/_dashboard/dashboard/quant/documentation/'
    | '/_dashboard/dashboard/quant/execution/'
    | '/_dashboard/dashboard/quant/optimization/'
    | '/_dashboard/dashboard/quant/simulation/'
    | '/_dashboard/dashboard/settings/invoices/'
    | '/_dashboard/dashboard/settings/subscription/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRoute: typeof DashboardRouteWithChildren
  AboutRoute: typeof AboutRoute
  CtraderCallbackRoute: typeof CtraderCallbackRoute
  AuthCodeRoute: typeof AuthCodeRoute
  UnsubscribeTokenRoute: typeof UnsubscribeTokenRoute
  VerifySlugRoute: typeof VerifySlugRoute
  AuthIndexRoute: typeof AuthIndexRoute
  AuthForgotPasswordIndexRoute: typeof AuthForgotPasswordIndexRoute
  AuthResetPasswordIndexRoute: typeof AuthResetPasswordIndexRoute
  AuthSignUpIndexRoute: typeof AuthSignUpIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/ctrader-callback': {
      id: '/ctrader-callback'
      path: '/ctrader-callback'
      fullPath: '/ctrader-callback'
      preLoaderRoute: typeof CtraderCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard': {
      id: '/_dashboard'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/': {
      id: '/auth/'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify/$slug': {
      id: '/verify/$slug'
      path: '/verify/$slug'
      fullPath: '/verify/$slug'
      preLoaderRoute: typeof VerifySlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unsubscribe/$token': {
      id: '/unsubscribe/$token'
      path: '/unsubscribe/$token'
      fullPath: '/unsubscribe/$token'
      preLoaderRoute: typeof UnsubscribeTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/code': {
      id: '/auth/code'
      path: '/auth/code'
      fullPath: '/auth/code'
      preLoaderRoute: typeof AuthCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/sign-up/': {
      id: '/auth/sign-up/'
      path: '/auth/sign-up'
      fullPath: '/auth/sign-up'
      preLoaderRoute: typeof AuthSignUpIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/reset-password/': {
      id: '/auth/reset-password/'
      path: '/auth/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/forgot-password/': {
      id: '/auth/forgot-password/'
      path: '/auth/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/dashboard/': {
      id: '/_dashboard/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardDashboardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard/propfirms': {
      id: '/_dashboard/dashboard/propfirms'
      path: '/dashboard/propfirms'
      fullPath: '/dashboard/propfirms'
      preLoaderRoute: typeof DashboardDashboardPropfirmsRouteRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard/communities': {
      id: '/_dashboard/dashboard/communities'
      path: '/dashboard/communities'
      fullPath: '/dashboard/communities'
      preLoaderRoute: typeof DashboardDashboardCommunitiesRouteRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard/trading-view/': {
      id: '/_dashboard/dashboard/trading-view/'
      path: '/dashboard/trading-view'
      fullPath: '/dashboard/trading-view'
      preLoaderRoute: typeof DashboardDashboardTradingViewIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard/trading-terminal/': {
      id: '/_dashboard/dashboard/trading-terminal/'
      path: '/dashboard/trading-terminal'
      fullPath: '/dashboard/trading-terminal'
      preLoaderRoute: typeof DashboardDashboardTradingTerminalIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard/settings/': {
      id: '/_dashboard/dashboard/settings/'
      path: '/dashboard/settings'
      fullPath: '/dashboard/settings'
      preLoaderRoute: typeof DashboardDashboardSettingsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard/risk/': {
      id: '/_dashboard/dashboard/risk/'
      path: '/dashboard/risk'
      fullPath: '/dashboard/risk'
      preLoaderRoute: typeof DashboardDashboardRiskIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard/report-bug/': {
      id: '/_dashboard/dashboard/report-bug/'
      path: '/dashboard/report-bug'
      fullPath: '/dashboard/report-bug'
      preLoaderRoute: typeof DashboardDashboardReportBugIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard/ranks/': {
      id: '/_dashboard/dashboard/ranks/'
      path: '/dashboard/ranks'
      fullPath: '/dashboard/ranks'
      preLoaderRoute: typeof DashboardDashboardRanksIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard/ranking/': {
      id: '/_dashboard/dashboard/ranking/'
      path: '/dashboard/ranking'
      fullPath: '/dashboard/ranking'
      preLoaderRoute: typeof DashboardDashboardRankingIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard/propfirms/': {
      id: '/_dashboard/dashboard/propfirms/'
      path: '/'
      fullPath: '/dashboard/propfirms/'
      preLoaderRoute: typeof DashboardDashboardPropfirmsIndexRouteImport
      parentRoute: typeof DashboardDashboardPropfirmsRouteRoute
    }
    '/_dashboard/dashboard/options-flow/': {
      id: '/_dashboard/dashboard/options-flow/'
      path: '/dashboard/options-flow'
      fullPath: '/dashboard/options-flow'
      preLoaderRoute: typeof DashboardDashboardOptionsFlowIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard/metrix/': {
      id: '/_dashboard/dashboard/metrix/'
      path: '/dashboard/metrix'
      fullPath: '/dashboard/metrix'
      preLoaderRoute: typeof DashboardDashboardMetrixIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard/economic-terminal/': {
      id: '/_dashboard/dashboard/economic-terminal/'
      path: '/dashboard/economic-terminal'
      fullPath: '/dashboard/economic-terminal'
      preLoaderRoute: typeof DashboardDashboardEconomicTerminalIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard/economic-calendar/': {
      id: '/_dashboard/dashboard/economic-calendar/'
      path: '/dashboard/economic-calendar'
      fullPath: '/dashboard/economic-calendar'
      preLoaderRoute: typeof DashboardDashboardEconomicCalendarIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard/discord/': {
      id: '/_dashboard/dashboard/discord/'
      path: '/dashboard/discord'
      fullPath: '/dashboard/discord'
      preLoaderRoute: typeof DashboardDashboardDiscordIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard/ctrader/': {
      id: '/_dashboard/dashboard/ctrader/'
      path: '/dashboard/ctrader'
      fullPath: '/dashboard/ctrader'
      preLoaderRoute: typeof DashboardDashboardCtraderIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard/copy-positions/': {
      id: '/_dashboard/dashboard/copy-positions/'
      path: '/dashboard/copy-positions'
      fullPath: '/dashboard/copy-positions'
      preLoaderRoute: typeof DashboardDashboardCopyPositionsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard/contact-us/': {
      id: '/_dashboard/dashboard/contact-us/'
      path: '/dashboard/contact-us'
      fullPath: '/dashboard/contact-us'
      preLoaderRoute: typeof DashboardDashboardContactUsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard/communities/': {
      id: '/_dashboard/dashboard/communities/'
      path: '/'
      fullPath: '/dashboard/communities/'
      preLoaderRoute: typeof DashboardDashboardCommunitiesIndexRouteImport
      parentRoute: typeof DashboardDashboardCommunitiesRouteRoute
    }
    '/_dashboard/dashboard/chart/': {
      id: '/_dashboard/dashboard/chart/'
      path: '/dashboard/chart'
      fullPath: '/dashboard/chart'
      preLoaderRoute: typeof DashboardDashboardChartIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard/affiliation/': {
      id: '/_dashboard/dashboard/affiliation/'
      path: '/dashboard/affiliation'
      fullPath: '/dashboard/affiliation'
      preLoaderRoute: typeof DashboardDashboardAffiliationIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard/admin/': {
      id: '/_dashboard/dashboard/admin/'
      path: '/dashboard/admin'
      fullPath: '/dashboard/admin'
      preLoaderRoute: typeof DashboardDashboardAdminIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard/accounts/': {
      id: '/_dashboard/dashboard/accounts/'
      path: '/dashboard/accounts'
      fullPath: '/dashboard/accounts'
      preLoaderRoute: typeof DashboardDashboardAccountsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard/propfirms/$slug': {
      id: '/_dashboard/dashboard/propfirms/$slug'
      path: '/$slug'
      fullPath: '/dashboard/propfirms/$slug'
      preLoaderRoute: typeof DashboardDashboardPropfirmsSlugRouteImport
      parentRoute: typeof DashboardDashboardPropfirmsRouteRoute
    }
    '/_dashboard/dashboard/communities/$slug': {
      id: '/_dashboard/dashboard/communities/$slug'
      path: '/$slug'
      fullPath: '/dashboard/communities/$slug'
      preLoaderRoute: typeof DashboardDashboardCommunitiesSlugRouteImport
      parentRoute: typeof DashboardDashboardCommunitiesRouteRoute
    }
    '/_dashboard/dashboard/admin/users': {
      id: '/_dashboard/dashboard/admin/users'
      path: '/dashboard/admin/users'
      fullPath: '/dashboard/admin/users'
      preLoaderRoute: typeof DashboardDashboardAdminUsersRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard/admin/servers': {
      id: '/_dashboard/dashboard/admin/servers'
      path: '/dashboard/admin/servers'
      fullPath: '/dashboard/admin/servers'
      preLoaderRoute: typeof DashboardDashboardAdminServersRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard/admin/partners': {
      id: '/_dashboard/dashboard/admin/partners'
      path: '/dashboard/admin/partners'
      fullPath: '/dashboard/admin/partners'
      preLoaderRoute: typeof DashboardDashboardAdminPartnersRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard/admin/communities': {
      id: '/_dashboard/dashboard/admin/communities'
      path: '/dashboard/admin/communities'
      fullPath: '/dashboard/admin/communities'
      preLoaderRoute: typeof DashboardDashboardAdminCommunitiesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard/admin/announcements': {
      id: '/_dashboard/dashboard/admin/announcements'
      path: '/dashboard/admin/announcements'
      fullPath: '/dashboard/admin/announcements'
      preLoaderRoute: typeof DashboardDashboardAdminAnnouncementsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard/settings/subscription/': {
      id: '/_dashboard/dashboard/settings/subscription/'
      path: '/dashboard/settings/subscription'
      fullPath: '/dashboard/settings/subscription'
      preLoaderRoute: typeof DashboardDashboardSettingsSubscriptionIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard/settings/invoices/': {
      id: '/_dashboard/dashboard/settings/invoices/'
      path: '/dashboard/settings/invoices'
      fullPath: '/dashboard/settings/invoices'
      preLoaderRoute: typeof DashboardDashboardSettingsInvoicesIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard/quant/simulation/': {
      id: '/_dashboard/dashboard/quant/simulation/'
      path: '/dashboard/quant/simulation'
      fullPath: '/dashboard/quant/simulation'
      preLoaderRoute: typeof DashboardDashboardQuantSimulationIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard/quant/optimization/': {
      id: '/_dashboard/dashboard/quant/optimization/'
      path: '/dashboard/quant/optimization'
      fullPath: '/dashboard/quant/optimization'
      preLoaderRoute: typeof DashboardDashboardQuantOptimizationIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard/quant/execution/': {
      id: '/_dashboard/dashboard/quant/execution/'
      path: '/dashboard/quant/execution'
      fullPath: '/dashboard/quant/execution'
      preLoaderRoute: typeof DashboardDashboardQuantExecutionIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard/quant/documentation/': {
      id: '/_dashboard/dashboard/quant/documentation/'
      path: '/dashboard/quant/documentation'
      fullPath: '/dashboard/quant/documentation'
      preLoaderRoute: typeof DashboardDashboardQuantDocumentationIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard/quant/algorithms/': {
      id: '/_dashboard/dashboard/quant/algorithms/'
      path: '/dashboard/quant/algorithms'
      fullPath: '/dashboard/quant/algorithms'
      preLoaderRoute: typeof DashboardDashboardQuantAlgorithmsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard/metrix/$userId/': {
      id: '/_dashboard/dashboard/metrix/$userId/'
      path: '/dashboard/metrix/$userId'
      fullPath: '/dashboard/metrix/$userId'
      preLoaderRoute: typeof DashboardDashboardMetrixUserIdIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard/quant/execution/$deploymentId': {
      id: '/_dashboard/dashboard/quant/execution/$deploymentId'
      path: '/dashboard/quant/execution/$deploymentId'
      fullPath: '/dashboard/quant/execution/$deploymentId'
      preLoaderRoute: typeof DashboardDashboardQuantExecutionDeploymentIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard/quant/algorithms/$algorithmId': {
      id: '/_dashboard/dashboard/quant/algorithms/$algorithmId'
      path: '/dashboard/quant/algorithms/$algorithmId'
      fullPath: '/dashboard/quant/algorithms/$algorithmId'
      preLoaderRoute: typeof DashboardDashboardQuantAlgorithmsAlgorithmIdRouteImport
      parentRoute: typeof DashboardRoute
    }
  }
}

interface DashboardDashboardCommunitiesRouteRouteChildren {
  DashboardDashboardCommunitiesSlugRoute: typeof DashboardDashboardCommunitiesSlugRoute
  DashboardDashboardCommunitiesIndexRoute: typeof DashboardDashboardCommunitiesIndexRoute
}

const DashboardDashboardCommunitiesRouteRouteChildren: DashboardDashboardCommunitiesRouteRouteChildren =
  {
    DashboardDashboardCommunitiesSlugRoute:
      DashboardDashboardCommunitiesSlugRoute,
    DashboardDashboardCommunitiesIndexRoute:
      DashboardDashboardCommunitiesIndexRoute,
  }

const DashboardDashboardCommunitiesRouteRouteWithChildren =
  DashboardDashboardCommunitiesRouteRoute._addFileChildren(
    DashboardDashboardCommunitiesRouteRouteChildren,
  )

interface DashboardDashboardPropfirmsRouteRouteChildren {
  DashboardDashboardPropfirmsSlugRoute: typeof DashboardDashboardPropfirmsSlugRoute
  DashboardDashboardPropfirmsIndexRoute: typeof DashboardDashboardPropfirmsIndexRoute
}

const DashboardDashboardPropfirmsRouteRouteChildren: DashboardDashboardPropfirmsRouteRouteChildren =
  {
    DashboardDashboardPropfirmsSlugRoute: DashboardDashboardPropfirmsSlugRoute,
    DashboardDashboardPropfirmsIndexRoute:
      DashboardDashboardPropfirmsIndexRoute,
  }

const DashboardDashboardPropfirmsRouteRouteWithChildren =
  DashboardDashboardPropfirmsRouteRoute._addFileChildren(
    DashboardDashboardPropfirmsRouteRouteChildren,
  )

interface DashboardRouteChildren {
  DashboardDashboardCommunitiesRouteRoute: typeof DashboardDashboardCommunitiesRouteRouteWithChildren
  DashboardDashboardPropfirmsRouteRoute: typeof DashboardDashboardPropfirmsRouteRouteWithChildren
  DashboardDashboardIndexRoute: typeof DashboardDashboardIndexRoute
  DashboardDashboardAdminAnnouncementsRoute: typeof DashboardDashboardAdminAnnouncementsRoute
  DashboardDashboardAdminCommunitiesRoute: typeof DashboardDashboardAdminCommunitiesRoute
  DashboardDashboardAdminPartnersRoute: typeof DashboardDashboardAdminPartnersRoute
  DashboardDashboardAdminServersRoute: typeof DashboardDashboardAdminServersRoute
  DashboardDashboardAdminUsersRoute: typeof DashboardDashboardAdminUsersRoute
  DashboardDashboardAccountsIndexRoute: typeof DashboardDashboardAccountsIndexRoute
  DashboardDashboardAdminIndexRoute: typeof DashboardDashboardAdminIndexRoute
  DashboardDashboardAffiliationIndexRoute: typeof DashboardDashboardAffiliationIndexRoute
  DashboardDashboardChartIndexRoute: typeof DashboardDashboardChartIndexRoute
  DashboardDashboardContactUsIndexRoute: typeof DashboardDashboardContactUsIndexRoute
  DashboardDashboardCopyPositionsIndexRoute: typeof DashboardDashboardCopyPositionsIndexRoute
  DashboardDashboardCtraderIndexRoute: typeof DashboardDashboardCtraderIndexRoute
  DashboardDashboardDiscordIndexRoute: typeof DashboardDashboardDiscordIndexRoute
  DashboardDashboardEconomicCalendarIndexRoute: typeof DashboardDashboardEconomicCalendarIndexRoute
  DashboardDashboardEconomicTerminalIndexRoute: typeof DashboardDashboardEconomicTerminalIndexRoute
  DashboardDashboardMetrixIndexRoute: typeof DashboardDashboardMetrixIndexRoute
  DashboardDashboardOptionsFlowIndexRoute: typeof DashboardDashboardOptionsFlowIndexRoute
  DashboardDashboardRankingIndexRoute: typeof DashboardDashboardRankingIndexRoute
  DashboardDashboardRanksIndexRoute: typeof DashboardDashboardRanksIndexRoute
  DashboardDashboardReportBugIndexRoute: typeof DashboardDashboardReportBugIndexRoute
  DashboardDashboardRiskIndexRoute: typeof DashboardDashboardRiskIndexRoute
  DashboardDashboardSettingsIndexRoute: typeof DashboardDashboardSettingsIndexRoute
  DashboardDashboardTradingTerminalIndexRoute: typeof DashboardDashboardTradingTerminalIndexRoute
  DashboardDashboardTradingViewIndexRoute: typeof DashboardDashboardTradingViewIndexRoute
  DashboardDashboardQuantAlgorithmsAlgorithmIdRoute: typeof DashboardDashboardQuantAlgorithmsAlgorithmIdRoute
  DashboardDashboardQuantExecutionDeploymentIdRoute: typeof DashboardDashboardQuantExecutionDeploymentIdRoute
  DashboardDashboardMetrixUserIdIndexRoute: typeof DashboardDashboardMetrixUserIdIndexRoute
  DashboardDashboardQuantAlgorithmsIndexRoute: typeof DashboardDashboardQuantAlgorithmsIndexRoute
  DashboardDashboardQuantDocumentationIndexRoute: typeof DashboardDashboardQuantDocumentationIndexRoute
  DashboardDashboardQuantExecutionIndexRoute: typeof DashboardDashboardQuantExecutionIndexRoute
  DashboardDashboardQuantOptimizationIndexRoute: typeof DashboardDashboardQuantOptimizationIndexRoute
  DashboardDashboardQuantSimulationIndexRoute: typeof DashboardDashboardQuantSimulationIndexRoute
  DashboardDashboardSettingsInvoicesIndexRoute: typeof DashboardDashboardSettingsInvoicesIndexRoute
  DashboardDashboardSettingsSubscriptionIndexRoute: typeof DashboardDashboardSettingsSubscriptionIndexRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardDashboardCommunitiesRouteRoute:
    DashboardDashboardCommunitiesRouteRouteWithChildren,
  DashboardDashboardPropfirmsRouteRoute:
    DashboardDashboardPropfirmsRouteRouteWithChildren,
  DashboardDashboardIndexRoute: DashboardDashboardIndexRoute,
  DashboardDashboardAdminAnnouncementsRoute:
    DashboardDashboardAdminAnnouncementsRoute,
  DashboardDashboardAdminCommunitiesRoute:
    DashboardDashboardAdminCommunitiesRoute,
  DashboardDashboardAdminPartnersRoute: DashboardDashboardAdminPartnersRoute,
  DashboardDashboardAdminServersRoute: DashboardDashboardAdminServersRoute,
  DashboardDashboardAdminUsersRoute: DashboardDashboardAdminUsersRoute,
  DashboardDashboardAccountsIndexRoute: DashboardDashboardAccountsIndexRoute,
  DashboardDashboardAdminIndexRoute: DashboardDashboardAdminIndexRoute,
  DashboardDashboardAffiliationIndexRoute:
    DashboardDashboardAffiliationIndexRoute,
  DashboardDashboardChartIndexRoute: DashboardDashboardChartIndexRoute,
  DashboardDashboardContactUsIndexRoute: DashboardDashboardContactUsIndexRoute,
  DashboardDashboardCopyPositionsIndexRoute:
    DashboardDashboardCopyPositionsIndexRoute,
  DashboardDashboardCtraderIndexRoute: DashboardDashboardCtraderIndexRoute,
  DashboardDashboardDiscordIndexRoute: DashboardDashboardDiscordIndexRoute,
  DashboardDashboardEconomicCalendarIndexRoute:
    DashboardDashboardEconomicCalendarIndexRoute,
  DashboardDashboardEconomicTerminalIndexRoute:
    DashboardDashboardEconomicTerminalIndexRoute,
  DashboardDashboardMetrixIndexRoute: DashboardDashboardMetrixIndexRoute,
  DashboardDashboardOptionsFlowIndexRoute:
    DashboardDashboardOptionsFlowIndexRoute,
  DashboardDashboardRankingIndexRoute: DashboardDashboardRankingIndexRoute,
  DashboardDashboardRanksIndexRoute: DashboardDashboardRanksIndexRoute,
  DashboardDashboardReportBugIndexRoute: DashboardDashboardReportBugIndexRoute,
  DashboardDashboardRiskIndexRoute: DashboardDashboardRiskIndexRoute,
  DashboardDashboardSettingsIndexRoute: DashboardDashboardSettingsIndexRoute,
  DashboardDashboardTradingTerminalIndexRoute:
    DashboardDashboardTradingTerminalIndexRoute,
  DashboardDashboardTradingViewIndexRoute:
    DashboardDashboardTradingViewIndexRoute,
  DashboardDashboardQuantAlgorithmsAlgorithmIdRoute:
    DashboardDashboardQuantAlgorithmsAlgorithmIdRoute,
  DashboardDashboardQuantExecutionDeploymentIdRoute:
    DashboardDashboardQuantExecutionDeploymentIdRoute,
  DashboardDashboardMetrixUserIdIndexRoute:
    DashboardDashboardMetrixUserIdIndexRoute,
  DashboardDashboardQuantAlgorithmsIndexRoute:
    DashboardDashboardQuantAlgorithmsIndexRoute,
  DashboardDashboardQuantDocumentationIndexRoute:
    DashboardDashboardQuantDocumentationIndexRoute,
  DashboardDashboardQuantExecutionIndexRoute:
    DashboardDashboardQuantExecutionIndexRoute,
  DashboardDashboardQuantOptimizationIndexRoute:
    DashboardDashboardQuantOptimizationIndexRoute,
  DashboardDashboardQuantSimulationIndexRoute:
    DashboardDashboardQuantSimulationIndexRoute,
  DashboardDashboardSettingsInvoicesIndexRoute:
    DashboardDashboardSettingsInvoicesIndexRoute,
  DashboardDashboardSettingsSubscriptionIndexRoute:
    DashboardDashboardSettingsSubscriptionIndexRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRoute: DashboardRouteWithChildren,
  AboutRoute: AboutRoute,
  CtraderCallbackRoute: CtraderCallbackRoute,
  AuthCodeRoute: AuthCodeRoute,
  UnsubscribeTokenRoute: UnsubscribeTokenRoute,
  VerifySlugRoute: VerifySlugRoute,
  AuthIndexRoute: AuthIndexRoute,
  AuthForgotPasswordIndexRoute: AuthForgotPasswordIndexRoute,
  AuthResetPasswordIndexRoute: AuthResetPasswordIndexRoute,
  AuthSignUpIndexRoute: AuthSignUpIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
